import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Box, CardContent, Card, Container,
} from '@material-ui/core';
import Dashboard3Drawers from '../../dashboard-3-drawers/Dashboard3Drawers';
import SeedAuthenticationRepository from '../../../repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../../route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../../dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../../images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../../icon/seed-icons';
import pageUtilsPropTypes from '../../page-prop-types';
import MyLinearProgress from '../../../widgets/MyLinearProgress';

const SeedMyLinearProgressPage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
  } = props;

  const [isLoading, setIsLoading] = React.useState(true);

  return (
    <Dashboard3Drawers
      titleId="seed.widgets.MyLinearProgress.title"
      routes={drawerRoutes}
      AuthenticationRepository={AuthenticationRepository}
      applicationName={applicationName}
      logo={logo}
      useBackButton
      icons={icons}
      breadcrumbs={[
        {
          id: 'widgets',
          href: '/widgets',
          titleId: 'seed.widgets.title',
        },
        {
          id: 'detail',
          titleId: 'seed.widgets.MyLinearProgress.title',
        },
      ]}
    >
      <Container maxWidth="sm">
        <Card>
          <MyLinearProgress
            isLoading={isLoading}
          />
          <CardContent />
        </Card>
      </Container>
      <Box mb={1} mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setIsLoading(!isLoading)}
        >
          Toggle MyLinearProgress
        </Button>
      </Box>
    </Dashboard3Drawers>
  );
};

SeedMyLinearProgressPage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  drawerRoutes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
  pageUtils: pageUtilsPropTypes.isRequired,
};

SeedMyLinearProgressPage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  applicationName: 'react-seed',
  logo: seedLogo,
  drawerRoutes: seedDrawerRoutes,
  icons: seedDashboard3DrawersIcons,
};

export default SeedMyLinearProgressPage;
